import IconScaleGradient, {
	IconScaleGradientProps as _IconScaleGradientProps,
} from './IconScaleGradient';

export { IconScaleGradient };
export type IconScaleGradientProps = _IconScaleGradientProps;
